module.exports = "/_next/static/images/2dc9cbe85204f963738b993cf4917540-wellDoneHiFive.svg.webp";